module.exports = __webpack_public_path__ + "img/zlpg_desc.49b0afa.png";